import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/licitacao/form_cad/aviso'


function CadastrarAvisoScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Aviso de Licitação" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarAvisoScreen;